module.exports = __webpack_public_path__ + "img/gaojing.f84298cb.png";